export default "/images/443c5cdd4e1729a1d1923028af88ffd5.avif";